import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'

export const AVATAR_SIZE_MAP = {
  large: 32,
  medium: 24,
  small: 16,
}

const sizeArray = Object.keys(AVATAR_SIZE_MAP)

function getShapeMixSize({ size: sizeText, shape }) {
  const size = sizeArray.includes(sizeText) ? AVATAR_SIZE_MAP[sizeText] : sizeText

  return {
    overflow: 'hidden',
    borderRadius: shape === 'circle' ? 'circle' : 'control',
    width: size,
    height: size,
    lineHeight: size,
  }
}

export default function initStyle() {
  return [
    registerThemeSpec('cmp.avatar', {
      size: props => {
        const { size, shape } = props

        return getShapeMixSize({ size, shape })
      },
    }),
  ]
}
